module.exports = __webpack_public_path__ + "static/media/ybcard.c613ccf7.png";